import { useDispatch, useSelector } from "react-redux";
import { getGroups, getSingleTankSensor, updateTankSensor, updateSensor, getSingleDeviceData } from "../../Api Methods/Api";
import { useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from "./tankSensorEntity.module.css";
import { format } from "date-fns";
import { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { SAMPLING_PERIOD_OPTIONS, POLARITY_OPTIONS, CONNECTION_DAY_OPTIONS } from "../../components/UI/Cards/Automations/VirutalSources/TankSensor/tankSensorOptions";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { ConfirmDialog } from "primereact/confirmdialog";
import house from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png'
import ullageIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ullage.png'
import Divider from '@mui/material/Divider'
import { EntityHeader } from "../../components/UI/EntityHeader/EntityHeader";
import Lottie from 'lottie-react';
import { Toast } from 'primereact/toast';
import successAnim from "../../assets/animations/success.json"
import failAnim from "../../assets/animations/fail.json"

const getTankFullness = (height, ullage) => {
    if (!height) return null;
    const heightInMm = height * 10;
    const liquidAmount = heightInMm - ullage;
    const percentFull = (liquidAmount / heightInMm) * 100;
    return percentFull.toFixed(0);
}

const TankSensorEntity = () => {

    const _sensor = useLoaderData();
    const sensor = _sensor[0]
    console.log(sensor);
    localStorage.removeItem('DeviceUUID')

    //  {
    //   id: '0867074081567338',
    //   ullage: 1,
    //   tank_height: 150,
    //   accelerometer_orientation: 9,
    //   battery_percentage: 99,
    //   firmware: '2.7',
    //   hardware: '05',
    //   last_seen: '2026-09-11T08:54:01.909Z',
    //   rtc_hour: 20,
    //   rtc_min: 41,
    //   rtc_sec: 19,
    //   dynamic_alarm_status_1: 0,
    //   dynamic_alarm_status_2: 0,
    //   static_alarm_status_1: 0,
    //   static_alarm_status_2: 0,
    //   static_alarm_status_3: 0,
    //   static_1_hysteresis: 20,
    //   static_2_hysteresis: 20,
    //   static_3_hysteresis: 20,
    //   static_1_polarity: 'lower',
    //   static_2_polarity: 'lower',
    //   static_3_polarity: 'lower',
    //   dynamic_1_polarity: 'lower',
    //   dynamic_2_polarity: 'lower',
    //   static_1_thresholdCm: 60,
    //   static_2_thresholdCm: 30,
    //   static_3_thresholdCm: 15,
    //   dynamic_1_rateOfChangeCm: 1,
    //   dynamic_2_rateOfChangeCm: 1,
    //   server_address: 'betaipio.m2mservices.mobi',
    //   server_port: 8081,
    //   log_interval_mins: 30,
    //   sampling_period: '1',
    //   connection_time_hour: 0,
    //   connection_time_min: 0,
    //   connection_days: 'mon,tue,wed,thu,fri,sat,sun',
    //   connection_time_end_hour: 23,
    //   connection_hour_frequency: 1,
    //   rcc_quality_score_filter: 2,
    //   rssi_quality_score_filter: 2,
    //   populated_on: '2026-09-10T20:41:20.000Z',
    //   sensorRowId: 89,
    //   sensorId: '0867074081567338',
    //   battery: 99,
    //   signal: 8,
    //   lastSeenAt: '2026-09-11T08:54:02.000Z',
    //   dateAdded: '2026-09-10T20:41:17.000Z',
    //   ownedByGID: null,
    //   billedToGID: null,
    //   billable: 1,
    //   firstInvoiceDate: null,
    //   billingFrequency: null,
    //   lastInvoiceDate: null,
    //   addedById: null,
    //   sensorStatus: 'online',
    //   sensorType: 10,
    //   customerBilledToGID: null,
    //   siteName: 'KNOWIO',
    //   online: 'YES',
    //   tag: 'Demo 456',
    //   subGroup: '',
    //   sensorName: '',
    //   virtualInput: '1',
    //   siteUUID: '9f2ecdc0-4cb7-407c-8c7b-e402f9f814ae',
    //   unlinked: 0
    // }

    const [localSensor, setLocalSensor] = useState(sensor);

    const sensorID = localSensor.id
    const ullage = localSensor.ullage
    const tankHeight = localSensor.tank_height
    const battery = localSensor.battery_percentage
    const firmware = localSensor.firmware
    const lastSeen = localSensor.last_seen
    const dateAdded = localSensor.dateAdded
    const ownedByGID = localSensor.ownedByGID
    const billedToGID = localSensor.billedToGID
    const billable = localSensor.billable
    const dateOfHardwareInvoice = localSensor.firstInvoiceDate
    const dateOfSaaSInvoice = localSensor.lastInvoiceDate
    const billingFrequency = localSensor.billingFrequency
    const customerBilledToGID = localSensor.customerBilledToGID
    const usedByName = localSensor.siteName
    const siteName = localSensor.tag
    const serial = localSensor.subGroup
    const accelerometer_orientation = localSensor.accelerometer_orientation
    const virtualInput = localSensor.virtualInput

    const rawTankFullness = ullage != null ? getTankFullness(tankHeight, ullage) : null;
    const tankPercent = rawTankFullness != null ? Number(rawTankFullness) : null;

    console.log('sensor stuff', localSensor)

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false);
    const [navigateToGroup, setNavigateToGroup] = useState(false);
    const [groups, setGroups] = useState([]);
    const [linkedInputPinName, setLinkedInputPinName] = useState(null);
    const [linkedInputPinNameLoaded, setLinkedInputPinNameLoaded] = useState(false);
    const [rocVisible, setRocVisible] = useState(false);
    const [changeRocDistance, setChangeRocDistance] = useState(false);
    const [editingAlarmIndex, setEditingAlarmIndex] = useState(null);
    const [draftDistance, setDraftDistance] = useState(null);
    const [newDistance1, setNewDistance1] = useState(null);
    const [newDistance2, setNewDistance2] = useState(null);
    const [changeOwnedBy, setChangeOwnedBy] = useState(false);
    const [newOwnerGroupName, setNewOwnerGroupName] = useState(null);
    const [changeBillable, setChangeBillable] = useState(false);
    const [changeBilledTo, setChangeBilledTo] = useState(false);
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(null);
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false);
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(null);
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false);
    const [newBillingFrequency, setNewBillingFrequency] = useState(null);
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false);
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState(null);
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false);
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState(null);

    const billingOptions = ["Monthly", "Annually"];

    const toast = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const companyName = useSelector(state => state.auth.companyName);
    const isAllowed = companyName === "EyeSpyFX" || companyName === "KNOWIO";
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE";

    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");
    const apiData = { token, client };

    const samplingPeriodLabel = (value) => SAMPLING_PERIOD_OPTIONS.find(o => o.value === Number(value))?.label || "Not set";
    const connectionDaysLabel = (value) => {
        if (!value) return "Not set";
        const days = value.split(",");
        return days.map(d => CONNECTION_DAY_OPTIONS.find(o => o.value === d)?.label || d).join(", ");
    };
    const polarityLabel = (value) => POLARITY_OPTIONS.find(o => o.value === value)?.label || value;

    // Owned by / billed to / customer billed to are stored as group IDs - resolve them against
    // the site's group list to show the group name instead, same as sensorEntity.js.
    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group) {
            groupName = group.name
        }
        return groupName
    }

    const staticAlarmValue = (thresholdCm, hysteresis, polarity, triggered) => {
        if (thresholdCm == null) return null;
        return `${polarityLabel(polarity)} than ${((thresholdCm / tankHeight) * 100).toFixed(0)}% (Revert tolerance ${hysteresis ?? 0}cm)${triggered ? " — Triggered" : ""}`;
    };

    const dynamicAlarmValue = (rateOfChangeCm, polarity, triggered) => {
        if (rateOfChangeCm == null) return null;
        if (rateOfChangeCm === 0) return "Disabled"
        return `${polarityLabel(polarity)} than ${rateOfChangeCm}cm between readings${triggered ? " — Triggered" : ""}`;
    };

    const getOrientationDefinition = (val) => {
        if (val >= 35) return "Poor alignment";
        if (val >= 25) return "Average alignment";
        return "Good alignment"
    }

    useEffect(() => {
        const GetGroups = async () => {
            const data = await getGroups(apiData, dispatch);
            setGroups(data);
        };
        GetGroups();
    }, []);

    useEffect(() => {
        if (navigateToLinkedSite && localSensor.siteUUID) {
            navigate(`/Dashboard/SiteView/${localSensor.siteUUID}`);
        }
    }, [navigateToLinkedSite]);

    useEffect(() => {
        if (navigateToGroup) {
            const groupClicked = groups.find(g => g.name === usedByName);
            if (groupClicked) {
                sessionStorage.setItem("groupClicked", groupClicked.name);
                sessionStorage.setItem("groupPath", groupClicked.group_path);
                sessionStorage.setItem("groupClickedID", groupClicked.id);
                navigate("/Dashboard/Groups/GroupSites/");
            }
        }
    }, [navigateToGroup]);

    useEffect(() => {
        if (newDistance1 == null && newDistance2 == null) return;

        const UpdateTank = async () => {
            let body = {};
            if (newDistance1 != null) body.dynamic_1_rateOfChangeCm = newDistance1;
            if (newDistance2 != null) body.dynamic_2_rateOfChangeCm = newDistance2;

            const res = await updateTankSensor(apiData, sensorID, body, dispatch)
            if (res.success) {
                setLocalSensor((prevSensor) => ({
                    ...prevSensor,
                    ...(newDistance1 != null ? { dynamic_1_rateOfChangeCm: newDistance1 } : {}),
                    ...(newDistance2 != null ? { dynamic_2_rateOfChangeCm: newDistance2 } : {}),
                }));
                toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Changes saved successfully', life: 3000 })
            } else {
                toast.current.show({ severity: 'error', summary: 'Something went wrong', detail: 'Please try again', life: 3000 })
            }
        }
        UpdateTank();
    }, [newDistance1, newDistance2])

    // ---------------- Ownership & billing (shared sensor columns) ----------------
    // These are generic sensor columns, so they're updated via the generic sensor API, exactly as in sensorEntity.js.
    // Tank-specific settings (e.g. rate of change distances) still go through updateTankSensor.
    const UpdateSensorDetails = async (columnName, newValue) => {
        const response = await updateSensor(apiData, {
            sensorID: localSensor.sensorId || sensorID,
            columnName,
            newValue,
        }, dispatch);

        if (response && response.success) {
            setLocalSensor(prevSensor => ({ ...prevSensor, [columnName]: newValue }));
            return true;
        }

        toast.current.show({ severity: 'error', summary: 'Something went wrong', detail: 'Please try again', life: 3000 });
        return false;
    };

    const showUpdatedToast = (detail) => {
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail, life: 3000 });
    };

    // preselect the current value each time one of the edit dialogs opens
    useEffect(() => {
        if (changeOwnedBy) setNewOwnerGroupName(convertGroupIDToName(ownedByGID) || null);
    }, [changeOwnedBy]);

    useEffect(() => {
        if (changeBilledTo) setNewBilledToGroupName(convertGroupIDToName(billedToGID) || null);
    }, [changeBilledTo]);

    useEffect(() => {
        if (changeCustomerBilledTo) setNewCustomerBilledToGroupName(convertGroupIDToName(customerBilledToGID) || null);
    }, [changeCustomerBilledTo]);

    useEffect(() => {
        if (changeBillingFrequency) {
            const match = billingOptions.find(option => option.toLowerCase() === String(billingFrequency || "").toLowerCase());
            setNewBillingFrequency(match || null);
        }
    }, [changeBillingFrequency]);

    useEffect(() => {
        if (changeDateOfFirstInvoice) setNewDateOfFirstInvoice(dateOfHardwareInvoice ? new Date(dateOfHardwareInvoice) : null);
    }, [changeDateOfFirstInvoice]);

    useEffect(() => {
        if (changeDateOfLastInvoice) setNewDateOfLastInvoice(dateOfSaaSInvoice ? new Date(dateOfSaaSInvoice) : null);
    }, [changeDateOfLastInvoice]);

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName)?.id;
        if (!newOwnerID) return;

        if (await UpdateSensorDetails("ownedByGID", newOwnerID)) {
            showUpdatedToast("Owner updated");
            setChangeOwnedBy(false);
        }
    };

    const updateBillable = async () => {
        if (await UpdateSensorDetails("billable", billable == 1 ? 0 : 1)) {
            showUpdatedToast("Billing status updated");
        }
    };

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName)?.id;
        if (!newBilledToID) return;

        if (await UpdateSensorDetails("billedToGID", newBilledToID)) {
            showUpdatedToast("Subscription updated");
            setChangeBilledTo(false);
        }
    };

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;

        if (await UpdateSensorDetails("customerBilledToGID", newCustomerBilledToID)) {
            showUpdatedToast("Customer billed to updated");
            setChangeCustomerBilledTo(false);
        }
    };

    const updateBillingFrequency = async () => {
        if (!newBillingFrequency) return;

        if (await UpdateSensorDetails("billingFrequency", newBillingFrequency.toLowerCase())) {
            setLocalSensor(prevSensor => ({ ...prevSensor, billingFrequency: newBillingFrequency }));
            showUpdatedToast("Billing frequency updated");
            setChangeBillingFrequency(false);
        }
    };

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : "";

        if (await UpdateSensorDetails("firstInvoiceDate", formattedDate)) {
            showUpdatedToast("Invoice date updated");
            setChangeDateOfFirstInvoice(false);
        }
    };

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : "";

        if (await UpdateSensorDetails("lastInvoiceDate", formattedDate)) {
            showUpdatedToast("Invoice date updated");
            setChangeDateOfLastInvoice(false);
        }
    };

    const groupOptions = groups.map(group => group.name).sort((a, b) => a.localeCompare(b));
    useEffect(() => {
        if (!localSensor.siteUUID || virtualInput == null) {
            setLinkedInputPinNameLoaded(true);
            return;
        }

        const GetLinkedSiteData = async () => {
            const SingleDeviceData = await getSingleDeviceData(apiData, localSensor.siteUUID);
            const deviceData = SingleDeviceData?.data?.[0];
            const deviceDetailsParsed = deviceData?.deviceDetails ? JSON.parse(deviceData.deviceDetails) : null;
            console.log('parsed device details', deviceDetailsParsed);
            setLinkedInputPinName(deviceDetailsParsed?.[parseInt(virtualInput)]?.pinName || null);
            setLinkedInputPinNameLoaded(true);
        }
        GetLinkedSiteData()
    }, [localSensor.siteUUID, virtualInput])

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: "50vw" }}
                onHide={() => setChangeOwnedBy(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        value={newOwnerGroupName}
                        placeholder="Select a group"
                        options={groupOptions}
                        onChange={(e) => setNewOwnerGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeOwnedBy(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newOwnerGroupName} onClick={updateOwnedBy} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billable confirm ── */}
            <ConfirmDialog
                visible={changeBillable}
                onHide={() => setChangeBillable(false)}
                header="Confirmation"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Yes"
                rejectLabel="No"
                defaultFocus="accept"
                accept={updateBillable}
                reject={() => toast.current.show({ severity: 'warn', summary: 'Cancelled', detail: 'Changes discarded', life: 3000 })}
                message={`Are you sure you want to ${billable == 1 ? "stop" : "start"} billing for this sensor?`}
            />

            {/* ── Inniovate bill to ── */}
            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: "50vw" }}
                onHide={() => setChangeBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        value={newBilledToGroupName}
                        placeholder="Select a group"
                        options={groupOptions}
                        onChange={(e) => setNewBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeBilledTo(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newBilledToGroupName} onClick={updateBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── RE:SURE bill to ── */}
            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: "50vw" }}
                onHide={() => setChangeCustomerBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        value={newCustomerBilledToGroupName}
                        placeholder="Select a group"
                        options={groupOptions}
                        onChange={(e) => setNewCustomerBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeCustomerBilledTo(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newCustomerBilledToGroupName} onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billing frequency ── */}
            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: "30vw" }}
                onHide={() => setChangeBillingFrequency(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        value={newBillingFrequency}
                        placeholder="Select a frequency"
                        options={billingOptions}
                        onChange={(e) => setNewBillingFrequency(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeBillingFrequency(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newBillingFrequency} onClick={updateBillingFrequency} />
                    </div>
                </div>
            </Dialog>

            {/* ── Date of hardware invoice ── */}
            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfFirstInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd mm yy"
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeDateOfFirstInvoice(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newDateOfFirstInvoice} onClick={updateDateOfFirstInvoice} />
                    </div>
                </div>
            </Dialog>

            {/* ── Date of 1st SaaS invoice ── */}
            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfLastInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={(e) => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd mm yy"
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setChangeDateOfLastInvoice(false)} />
                        <Button icon="pi pi-save" label="Save" disabled={!newDateOfLastInvoice} onClick={updateDateOfLastInvoice} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Rate of change alarm"
                visible={rocVisible}
                style={{ width: "35vw", maxWidth: "480px"}}
                onHide={() => setRocVisible(false)}
            >
                <div className={classes.dialogContainer}>
                    <div className={classes.messageGroup}>
                        <h4 className={classes.subText}>What would you like to change?</h4>
                        {localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] >= 1 && (
                            <h4 className={classes.severityText}>Disabling this alarm will reset its distance to default when re-enabled.</h4>
                        )}
                    </div>
                    <div className={classes.btnRow}>
                        <Button
                            label={localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] >= 1 ? "Disable alarm" : "Enable alarm"}
                            severity={localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] >= 1 ? "danger" : ""}
                            style={{ backgroundColor: localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] < 1 ? "var(--Primary-Color)" : '' }}
                            onClick={() => {
                                setRocVisible(false);
                                const isEnabled = localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] >= 1;
                                const value = isEnabled ? 0 : 1;
                                if (editingAlarmIndex === 1) setNewDistance1(value);
                                else if (editingAlarmIndex === 2) setNewDistance2(value);
                            }}
                        />
                        <Button
                            label="Change distance"
                            severity="secondary"
                            onClick={() => {
                                setDraftDistance(localSensor[`dynamic_${editingAlarmIndex}_rateOfChangeCm`] ?? 1);
                                setChangeRocDistance(true);
                                setRocVisible(false);
                            }}
                        />
                    </div>

                </div>
            </Dialog>

            <Dialog
                header="Change distance"
                visible={changeRocDistance}
                style={{ width: "30vw", maxWidth: "460px"}}
                onHide={() => setChangeRocDistance(false)}
            >
                <div className={classes.dialogContainer}>
                    <InputNumber
                        value={draftDistance ?? 1}
                        onValueChange={(e) => setDraftDistance(e.value)}
                        showButtons
                        min={1}
                        max={500}
                        suffix="cm"
                        incrementButtonClassName={classes.spinnerBtn}
                        decrementButtonClassName={classes.spinnerBtn}
                    />
                    <div className={classes.btnRow}>
                        <Button label="Cancel" severity="secondary" onClick={() => setChangeRocDistance(false)} />
                        <Button
                            label="Save"
                            style={{ backgroundColor: 'var(--Primary-Color)', borderColor: 'transparent' }}
                            onClick={() => {
                                setChangeRocDistance(false);
                                if (editingAlarmIndex === 1) setNewDistance1(draftDistance);
                                else if (editingAlarmIndex === 2) setNewDistance2(draftDistance);
                            }}
                        />
                    </div>
                </div>
            </Dialog>
            <div className={classes.activtyPage_container}>
                <EntityHeader
                    isTankSensorEntity={true}
                    titlePart1={linkedInputPinName || (linkedInputPinNameLoaded ? 'Tank Sensor' : '')}
                    titlePart2={siteName}
                    icon={ullageIcon}
                    iconText={ullage != null ? (tankPercent ? `${tankPercent.toFixed(0)}%` : `${tankHeight - (ullage / 10)} cm`) : "No data"}
                    setNavigate={setNavigateToLinkedSite}
                    secondaryText={lastSeen ? `Updated ${format(new Date(lastSeen), "MMM do, yyyy - HH:mm")}` : null}
                />

                <Divider style={{ marginTop: '8px', marginBottom: '8px'}}/>

                <p className={classes.leadingHeader}>Device</p>
                <div className={classes.container}>
                    <Stats2 title={"Sensor ID"} value={sensorID} isLoadingStats={false} isStatic={true} />
                    {localSensor.sensorName && (
                        <Stats2 title={"Sensor name"} value={localSensor.sensorName} isLoadingStats={false} isStatic={true} />
                    )}
                    {serial && (
                        <Stats2 title={"Serial number"} value={serial} isLoadingStats={false} isStatic={true} />
                    )}
                    <Stats2 title={"Firmware"} value={firmware || "Unknown"} isLoadingStats={false} isStatic={true} />
                    <Stats2 title={"Battery"} value={battery != null ? `${battery}%` : "No data"} isLoadingStats={false} isStatic={true} />
                    {lastSeen && (
                        <Stats2 title={"Last updated"} value={format(new Date(lastSeen), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                    )}
                    <Stats2 title={"Accelerometer orientation"} value={getOrientationDefinition(accelerometer_orientation)} isLoadingStats={false} isStatic={true} />
                    {linkedInputPinName && (
                        <Stats2 title={"Input name"} value={linkedInputPinName} isLoadingStats={false} isStatic={true} />
                    )}
                </div>

                <p className={classes.sectionHeader}>Tank level</p>
                <div className={classes.containerShort}>
                    <Stats2 title={"Tank height"} value={tankHeight != null ? `${tankHeight} cm` : "Not set"} isLoadingStats={false} isStatic={true} />
                    <Stats2
                        title={"Tank level"}
                        value={ullage != null ? (tankPercent ? `${tankPercent.toFixed(0)}%` : `${tankHeight - (ullage/10)} cm`) : "No data"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                </div>

                <p className={classes.sectionHeader}>Alarms</p>
                <div className={classes.container}>
                    {[1, 2, 3].map(i => {
                        const value = staticAlarmValue(
                            localSensor[`static_${i}_thresholdCm`],
                            localSensor[`static_${i}_hysteresis`],
                            localSensor[`static_${i}_polarity`],
                            localSensor[`static_alarm_status_${i}`] === 1
                        );
                        return value ? <Stats2 key={`static-${i}`} title={`Tank level alarm ${i}`} value={value} isLoadingStats={false} isStatic={true} /> : null;
                    })}

                    {[1, 2].map(i => {
                        const value = dynamicAlarmValue(
                            localSensor[`dynamic_${i}_rateOfChangeCm`],
                            localSensor[`dynamic_${i}_polarity`],
                            localSensor[`dynamic_alarm_status_${i}`] === 1
                        );
                        return value ? (
                            <Stats2
                                key={`dynamic-${i}`}
                                title={`Rate of change alarm ${i}`}
                                value={value}
                                isLoadingStats={false}
                                isStatic={true}
                                editable={true}
                                setChangeDynamicAlarm={() => { setEditingAlarmIndex(i); setRocVisible(true); }}
                            />
                        ) : null;
                    })}
                </div>

                <p className={classes.sectionHeader}>Assignment</p>
                <div className={classes.container}>
                    {siteName && (
                        <Stats2 title={"Linked to"} value={siteName} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} />
                    )}
                    {dateAdded && (
                        <Stats2 title={"Date linked"} value={format(new Date(dateAdded), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                    )}
                    {usedByName && (
                        <Stats2 title={"Used by"} value={usedByName} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup} />
                    )}
                    {isAllowed && (
                        <Stats2
                            title={"Owned by"}
                            value={convertGroupIDToName(ownedByGID) || "Not set"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeOwnedBy={setChangeOwnedBy}
                            editable={isAllowed}
                        />
                    )}
                </div>

                <p className={classes.sectionHeader}>Monitoring settings</p>
                <div className={classes.container}>
                    {localSensor.log_interval_mins != null && (
                        <Stats2 title={"Level Check Frequency"} value={`${localSensor.log_interval_mins} min`} isLoadingStats={false} isStatic={true} />
                    )}
                    {localSensor.sampling_period != null && (
                        <Stats2 title={"Rate of Change Check Interval"} value={samplingPeriodLabel(localSensor.sampling_period)} isLoadingStats={false} isStatic={true} />
                    )}
                    {isAllowed && (
                        localSensor.rcc_quality_score_filter != null && (
                            <Stats2 title={"RCC quality score filter"} value={localSensor.rcc_quality_score_filter} isLoadingStats={false} isStatic={true} />
                        )
                    )}

                    {isAllowed && (
                        localSensor.rssi_quality_score_filter != null && (
                            <Stats2 title={"RSSI quality score filter"} value={localSensor.rssi_quality_score_filter} isLoadingStats={false} isStatic={true} />
                        )
                    )}
                </div>

                <p className={classes.sectionHeader}>Billing</p>
                <div className={classes.container}>
                    {isAllowed && (
                        <Stats2
                            title={"Billable"}
                            value={billable == 1 ? "Yes" : "No"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeBillable={setChangeBillable}
                            isAllowedToChange={isAllowed}
                            editable={true}
                        />
                    )}

                    {(billable == 1 && isAllowed) && (
                        <Stats2
                            title={"Inniovate bill to"}
                            value={convertGroupIDToName(billedToGID) || "Not set"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeBilledTo={setChangeBilledTo}
                            isAllowedToChange={isAllowed}
                            editable={isAllowed}
                        />
                    )}

                    {isAllowed && (
                        <Stats2
                            title={"Billing frequency"}
                            value={billingFrequency ?? "Not set"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeBillingFrequency={setChangeBillingFrequency}
                            isAllowedToChange={isAllowed}
                            editable={true}
                        />
                    )}

                    {isAllowed && (
                        <Stats2
                            title={"Date of hardware invoice"}
                            value={dateOfHardwareInvoice ? format(new Date(dateOfHardwareInvoice), "dd/MM/yyyy") : "Not set"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice}
                            isAllowedToChange={isAllowed}
                            editable={true}
                        />
                    )}

                    {isAllowed && (
                        <Stats2
                            title={"Date of 1st SaaS invoice"}
                            value={dateOfSaaSInvoice ? format(new Date(dateOfSaaSInvoice), "dd/MM/yyyy") : "Not set"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeDateOfLastInvoice={setChangeDateOfLastInvoice}
                            isAllowedToChange={isAllowed}
                            editable={true}
                        />
                    )}

                    {isCustomerBillingAllowed && (
                        <Stats2
                            title={"RE:SURE bill to"}
                            value={convertGroupIDToName(customerBilledToGID) || "No"}
                            isLoadingStats={false}
                            isStatic={true}
                            setChangeBilledTo={setChangeCustomerBilledTo}
                            isAllowedToChange={true}
                            editable={true}
                        />
                    )}
                </div>


                    {/* 
                    {(localSensor.connection_time_hour != null && localSensor.connection_time_min != null) && (
                        <Stats2
                            title={"First connection time"}
                            value={`${String(localSensor.connection_time_hour).padStart(2, "0")}:${String(localSensor.connection_time_min).padStart(2, "0")} UTC`}
                            isLoadingStats={false}
                            isStatic={true}
                        />
                    )}
                    
                    {localSensor.connection_days && (
                        <Stats2 title={"Connection days"} value={connectionDaysLabel(localSensor.connection_days)} isLoadingStats={false} isStatic={true} />
                    )}\
                    */}

            </div>
        </>
    );
};

export default TankSensorEntity;

export async function tankSensorLoader({ params }) {
    const IMEI = params.IMEI;
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");

    const response = await getSingleTankSensor({ token, client }, IMEI);
    console.log(response);
    return response.data;
}
